// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e855ef34","453":"54342de2"}[chunkId] + ".chunk.js";
};